module.exports = __webpack_public_path__ + "static/media/invoeasePreview.225412f0.jpg";